var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "32px",
    viewBox: "0 0 26 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unlock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version-4.3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A08b",
    transform: "translate(-1099.000000, -79.000000)",
    fill: "#717171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1079.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_notif_unlocked",
    transform: "translate(20.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4,10.6666733 L20.8000105,10.6666733 L20.8000105,7.61905524 C20.8000105,3.41333787 17.2160046,0 12.8,0 C8.38399958,0 4.8,3.41333787 4.8,7.61905524 L4.8,10.6666733 L3.2,10.6666733 C1.44000105,10.6666733 0,12.0381005 0,13.7142914 L0,28.9523819 C0,30.6285719 1.44000105,32 3.2,32 L22.4,32 C24.1600094,32 25.6,30.6285719 25.6,28.9523819 L25.6,13.7142914 C25.6,12.0381005 24.1600094,10.6666733 22.4,10.6666733 L22.4,10.6666733 Z M12.8,25.6 C10.4533347,25.6 8.53333333,23.6799986 8.53333333,21.3333333 C8.53333333,18.9866653 10.4533347,17.0666667 12.8,17.0666667 C15.1466653,17.0666667 17.0666667,18.9866653 17.0666667,21.3333333 C17.0666667,23.6799986 15.1466653,25.6 12.8,25.6 L12.8,25.6 Z M17.0666667,10.6666667 L8.53333333,10.6666667 L8.53333333,8.15686565 C8.53333333,6.01098175 10.4464483,4.26666667 12.7999955,4.26666667 C15.1535427,4.26666667 17.0666667,6.01098175 17.0666667,8.15686565 L17.0666667,10.6666667 L17.0666667,10.6666667 Z",
    id: "unlock"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.fe9b518f5850475157556edc473c5f0e.svg";
export { ForwardRef as ReactComponent };